import { render, staticRenderFns } from "./TrademarkOppositionStatusList.vue?vue&type=template&id=44dc302f&"
import script from "./TrademarkOppositionStatusList.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionStatusList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkOppositionStatusList.vue?vue&type=style&index=0&id=44dc302f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports